<script>
import Layout from '@layouts/main'

export default {
  page: {
    title: '頁面逾時',
    meta: [
      { name: 'description', content: 'The page timed out while loading.' },
    ],
  },
  components: { Layout },
}
</script>

<template>
  <div class="page404">
    <div class="page404__box">
      <div class="page404__img">
        <template v-if="$appType() === 'ipetbooking'">
          <img :src="require(`@assets/images/logo-dark.svg`)" class="logo-pet" />
          <img :src="require(`@assets/images/login_logo.svg`)" class="logo-site" />
        </template>
        <template v-if="$appType() === 'dingbeauty'">
          <img :src="require(`@assets/images/dingBeauty-logo.svg`)" class="logo-site" />
        </template>
      </div>
      <div class="page404__content">
        <h1 class="fw-regular">
          頁面連線已逾時
        </h1>
        <p class="my-5 text-text">請重新載入頁面，謝謝。</p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
.title {
  text-align: center;
}
</style>
